import inputMask from '@tadashi/mask';

window.storeTheme = window.storeTheme || ({} as StoreTheme);
Object.assign(window.storeTheme, { helpers: Object.assign(window.storeTheme.helpers || {}, { inputMask }) });

export default {};
